import CommonImg from "@/components/Common/Img";

import PlusButtonIcon from "@/assets/images/plug-button-icon.png";

type Props = { onClick: () => void };
export default function CommonPlusButton({ onClick }: Props) {
  return (
    <CommonImg
      src={PlusButtonIcon}
      alt="Plus Button"
      className="size-[28px]"
      onClick={onClick}
    />
  );
}
